// bao migrate skip
import * as ko from "knockout";
import TabPage from "../../../factories/tab-page";
import GenericListTab from "../../../factories/generic-list-tab";
class ShiftbookTransferDefinition extends GenericListTab {
    DialogWidth = 600;
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.Models.subscribe(() => {
            this.Selection([]);
        });
    }
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
}
export default ShiftbookTransferDefinition;